export default __webpack_public_path__ + "static/media/background2.33c3e961.png";